// extracted by mini-css-extract-plugin
export var scheduleTitle = "schedule-module--scheduleTitle--06c35";
export var slideUp = "schedule-module--slideUp--46559";
export var slideUpLarge = "schedule-module--slideUpLarge--e388f";